<template>
  <div>
    <KTCodePreview v-bind:title="'Báo cáo XNT'">
      <template v-slot:preview>
        <!-- Header session -->
        <b-row class="mb-5">
          <b-col md="2">
            <date-picker
              placeholder="Chọn tháng"
              class="form-control-sm"
              :config="dpConfigs.monthReport"
              v-model="dpForm.monthReport"
            ></date-picker>
          </b-col>
          <b-button variant="warning" size="sm" @click="excuteReport()"
            >Chạy báo cáo</b-button
          >
          <b-col md="2">
            <b-button
              variant="primary"
              size="sm"
              @click="reportClick()"
              :disabled="!isReportReady"
              >Xuất báo cáo</b-button
            >
          </b-col>
        </b-row>
        <b-row class="mb-5">
          <b-col md="2">
            <b-input
              v-model="searchProduct"
              size="sm"
              placeholder="Tìm theo sản phẩm"
              v-on:keyup.enter="onFilter()"
            />
          </b-col>
          <b-button variant="primary" size="sm" @click="filterReport()"
            >Lọc</b-button
          >
        </b-row>
        <b-table
          :items="listItem"
          :fields="fields"
          bordered
          hover
          :busy="onLoading"
        >
          <template slot="thead-top">
            <tr>
              <th class="text-center">Sản phẩm</th>
              <th class="text-center" colspan="3">Đầu kỳ</th>
              <th class="text-center" colspan="3">Phát sinh trong kỳ nhập</th>
              <th class="text-center" colspan="3">Phát sinh trong kỳ xuất</th>
              <th class="text-center" colspan="3">Cuối kỳ</th>
            </tr>
          </template>
          <template v-slot:table-busy>
            <vcl-table :speed="5" :animate="true" :columns="6"></vcl-table>
          </template>
          <template v-slot:cell(productName)="row">
            <div class="d-flex align-items-center">
              <ProductImage
                :src="row.item.productImageUrl"
                :alt="row.item.productName"
                class="mr-2"
              />
              <div class="d-flex flex-column">
                <span
                  v-if="row.item.barCode"
                  class="text-muted"
                  style="font-size: 0.8rem"
                >
                  {{ row.item.barCode }}
                </span>
                <span
                  v-if="row.item.productCode"
                  class="text-muted"
                  style="font-size: 0.8rem"
                >
                  {{ row.item.productCode }}
                </span>
                <span
                  class="font-weight-bold"
                  style="white-space: normal; color: #3699ff"
                >
                  {{ row.item.productName }}
                </span>
              </div>
            </div>
          </template>
        </b-table>
        <b-row>
          <b-col>
            <p class="mt-3 text-dark" style="font-weight: 500">
              Tổng số :
              {{ convertPrice(totalItem) }}
            </p>
          </b-col>
          <b-col>
            <b-pagination-nav
              class="customPagination"
              v-if="numberOfPage >= 2"
              :link-gen="linkGen"
              :number-of-pages="numberOfPage"
              use-router
              @change="filterReport"
              align="right"
              first-class="page-item-first btn btn-icon mr-1 btn-sm my-1"
              prev-class="page-item-prev btn btn-icon mr-1 btn-sm my-1"
              next-class="page-item-next btn btn-icon btn-sm mr-1 my-1 "
              last-class="page-item-last btn btn-icon btn-sm my-1 "
              page-class="btn btn-icon btn-sm border-0 mr-1 my-1"
            >
              <template v-slot:first-text>
                <span>
                  <i class="ki ki-double-arrow-back icon-xs"></i>
                </span>
              </template>

              <template v-slot:prev-text>
                <i class="ki ki-arrow-back icon-xs"></i>
              </template>

              <template v-slot:next-text>
                <i class="ki ki-arrow-next icon-xs"></i>
              </template>

              <template v-slot:last-text>
                <span class="text-info">
                  <i class="ki ki-double-arrow-next icon-xs"></i>
                </span>
              </template>
            </b-pagination-nav>
          </b-col>
        </b-row>
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import moment from 'moment';
import { BASE_URL } from '@/utils/constants';
import { vi } from 'vuejs-datepicker/dist/locale';
import { VclTable } from 'vue-content-loading';
import datePicker from 'vue-bootstrap-datetimepicker';
import axios from 'axios';
import ApiService from '@/core/services/api.service';
import { makeToastFaile, makeToastSuccess, convertPrice } from '@/utils/common';
import fileDownload from '@/utils/file-download';
import ProductImage from '@/view/components/products/ProductImage.vue';

export default {
  data() {
    return {
      dpForm: {
        monthReport: '',
      },
      dpConfigs: {
        monthReport: {
          format: 'MM/YYYY',
          useCurrent: false,
          showClear: true,
          showClose: true,
          minDate: false,
          maxDate: false,
          locale: 'vi',
          sideBySide: true,
        },
      },
      onLoading: false,
      disabledDates: {},
      format: 'MM-yyyy',
      language: vi,
      isReportReady: false,
      fields: [
        {
          key: 'productName',
          label: '',
          thStyle: {
            textAlign: 'center',
            color: 'rgb(24, 28, 50)',
            width: '20%',
          },
        },
        {
          key: 'openningInStock',
          label: 'Tồn',
          thStyle: {
            textAlign: 'center',
            color: 'rgb(24, 28, 50)',
            width: '4%',
          },
          tdClass: 'text-right',
          formatter: (value) => {
            return convertPrice(value);
          },
        },
        {
          key: 'openningPrice',
          label: 'Đơn giá',
          thStyle: {
            textAlign: 'center',
            color: 'rgb(24, 28, 50)',
            width: '8%',
          },
          tdClass: 'text-right',
          formatter: (value) => {
            return convertPrice(value);
          },
        },
        {
          key: 'openningValue',
          label: 'Giá trị',
          thStyle: {
            textAlign: 'center',
            color: 'rgb(24, 28, 50)',
            width: '8%',
          },
          tdClass: 'text-right',
          formatter: (value) => {
            return convertPrice(value);
          },
        },
        {
          key: 'quantityIn',
          label: 'SL',
          thStyle: {
            textAlign: 'center',
            color: 'rgb(24, 28, 50)',
            width: '4%',
          },
          tdClass: 'text-right',
          formatter: (value) => {
            return convertPrice(value);
          },
        },
        {
          key: 'importPrice',
          label: 'Đơn giá',
          thStyle: {
            textAlign: 'center',
            color: 'rgb(24, 28, 50)',
            width: '8%',
          },
          tdClass: 'text-right',
          formatter: (value) => {
            return convertPrice(value);
          },
        },
        {
          key: 'valueIn',
          label: 'Giá trị',
          thStyle: {
            textAlign: 'center',
            color: 'rgb(24, 28, 50)',
            width: '8%',
          },
          tdClass: 'text-right',
          formatter: (value) => {
            return convertPrice(value);
          },
        },
        {
          key: 'quantityOut',
          label: 'SL',
          thStyle: {
            textAlign: 'center',
            color: 'rgb(24, 28, 50)',
            width: '4%',
          },
          tdClass: 'text-right',
          formatter: (value) => {
            return convertPrice(value);
          },
        },
        {
          key: 'exportPrice',
          label: 'Đơn giá',
          thStyle: {
            textAlign: 'center',
            color: 'rgb(24, 28, 50)',
            width: '8%',
          },
          tdClass: 'text-right',
          formatter: (value) => {
            return convertPrice(value);
          },
        },
        {
          key: 'valueOut',
          label: 'Giá trị',
          thStyle: {
            textAlign: 'center',
            color: 'rgb(24, 28, 50)',
            width: '8%',
          },
          tdClass: 'text-right',
          formatter: (value) => {
            return convertPrice(value);
          },
        },
        {
          key: 'closingInStock',
          label: 'Tồn',
          thStyle: {
            textAlign: 'center',
            color: 'rgb(24, 28, 50)',
            width: '4%',
          },
          tdClass: 'text-right',
          formatter: (value) => {
            return convertPrice(value);
          },
        },
        {
          key: 'closingPrice',
          label: 'Đơn giá',
          thStyle: {
            textAlign: 'center',
            color: 'rgb(24, 28, 50)',
            width: '8%',
          },
          tdClass: 'text-right',
          formatter: (value) => {
            return convertPrice(value);
          },
        },
        {
          key: 'closingValue',
          label: 'Giá trị',
          thStyle: {
            textAlign: 'center',
            color: 'rgb(24, 28, 50)',
            width: '8%',
          },
          tdClass: 'text-right',
          formatter: (value) => {
            return convertPrice(value);
          },
        },
        {
          key: 'importDate',
          label: 'Ngày nhập',
          thStyle: {
            textAlign: 'center',
            color: 'rgb(24, 28, 50)',
            width: '8%',
          },
        },
        {
          key: 'subProviderName',
          label: 'NCC phụ',
          thStyle: {
            textAlign: 'center',
            color: 'rgb(24, 28, 50)',
            width: '8%',
          },
        },
        {
          key: 'subProviderCode',
          label: 'Mã NCC phụ',
          thStyle: {
            textAlign: 'center',
            color: 'rgb(24, 28, 50)',
            width: '8%',
          },
        },
      ],
      listItem: [],
      searchProduct: '',
      linkGen: (pageNum) => {
        return pageNum === 1 ? '?' : `?page=${pageNum}`;
      },
      page: 1,
      totalItem: 0,
    };
  },
  methods: {
    convertPrice,
    excuteReport() {
      const monthReport = this.dpForm.monthReport
        ? moment(this.dpForm.monthReport, 'MM/YYYY').format('yyyy-MM')
        : null;
      this.isReportReady = false;
      ApiService.query('/v1/inventory-summary-reports/execute', {
        params: {
          monthReport: monthReport,
        },
      })
        .then((response) => {
          this.isReportReady = true;
          if (response.data.data) {
            makeToastSuccess(response.data.data.message);
          }
        })
        .catch((err) => {
          if (!err.response) {
            // network error
            makeToastFaile('Lỗi!');
          } else {
            const message = err.response.data.message;
            makeToastFaile(message);
          }
          this.$nprogress.done();
        });
    },
    reportClick: async function() {
      const monthReport = this.dpForm.monthReport
        ? moment(this.dpForm.monthReport, 'MM/YYYY').format('yyyy-MM')
        : null;
      if (!monthReport) {
        makeToastFaile('Vui lòng chọn tháng chạy báo cáo!');
        return;
      }
      const url = `${BASE_URL}v1/inventory-summary-reports/report?monthReport=${monthReport}`;
      await axios({
        url: url,
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        const fileName = fileDownload.getFileName(response);
        fileDownload.createFile(response.data, fileName);
      });
    },
    filterReport() {
      const monthReport = this.dpForm.monthReport
        ? moment(this.dpForm.monthReport, 'MM/YYYY').format('yyyy-MM')
        : null;
      if (!monthReport) {
        return makeToastFaile('Vui lòng chọn tháng xem báo cáo NXT!');
      }
      this.page = this.$route.query.page;
      if (!this.page) {
        this.page = 1;
      }
      const params = {
        monthReport: monthReport,
        searchProduct: this.searchProduct,
        page: this.page,
        limit: 30,
      };
      this.onLoading = true;
      this.isReportReady = false;
      ApiService.query('/v1/inventory-summary-reports/', {
        params,
      })
        .then((response) => {
          this.isReportReady = true;
          this.listItem = response.data.data.dataset;
          this.numberOfPage = response.data.data.totalPage;
          this.totalItem = response.data.data.totalRow;
          this.onLoading = false;
        })
        .catch((err) => {
          if (!err.response) {
            // network error
            makeToastFaile('Lỗi!');
          } else {
            const message = err.response.data.message;
            makeToastFaile(message);
          }
          this.$nprogress.done();
          this.onLoading = false;
        });
    },
    onFilter() {
      this.$route.query.page = 1;
      this.$router.push({
        name: 'report-inventory-summary',
      });
      this.filterReport();
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Báo cáo XNT', route: 'report-inventory-summary' },
    ]);
  },
  created() {},
  components: {
    KTCodePreview,
    datePicker,
    VclTable,
    ProductImage,
  },
};
</script>

<style scoped>
.bootstrap-datetimepicker-widget.dropdown-menu {
  width: 21em;
}
.table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
  border-top: 1px solid #ecf0f3;
}
.table.b-table.table-sm > thead > tr > [aria-sort]:not(.b-table-sort-icon-left),
.table.b-table.table-sm
  > tfoot
  > tr
  > [aria-sort]:not(.b-table-sort-icon-left) {
  background-position: right calc(1.5rem / 2) center;
  padding-right: calc(0.3rem + 0.65em);
}
.btn.btn-icon.btn-sm,
.btn-group-sm > .btn.btn-icon {
  height: calc(1.35em + 1.1rem + 2px);
  width: auto;
}
.customPagination /deep/ .page-item-first .page-link {
  background-color: #ecf1f6;
}

.customPagination /deep/ .page-item-prev .page-link {
  background-color: #ecf1f6;
}
.customPagination /deep/ .page-item-next .page-link {
  background-color: #ecf1f6;
}
.customPagination /deep/ .page-item-last .page-link {
  background-color: #ecf1f6;
}

.customPagination /deep/ .page-item .page-link {
  border-radius: 0.42rem;
  font-size: 0.9rem;
  line-height: 1rem;
  font-weight: 600;
  justify-content: center;
  align-items: center;
  -webkit-box-align: center;
  height: 2.25rem;
  min-width: 2.25rem;
  padding: 0.5rem;
  color: #7e8299;
}

.customPagination /deep/ .page-item {
  color: #ecf1f6;
}

.customPagination /deep/ .page-item .router-link-exact-active {
  color: #fff;
}

.customPagination /deep/ .page-item .page-link {
  font-weight: 500;
  font-size: 1rem;
}

.customPagination /deep/ .page-item .page-link:hover i {
  color: #fff;
}

.customPagination /deep/ .page-item .page-link:hover {
  background-color: #3699ff;
  color: #fff;
  transition: color 0.15s ease, background-color 0.15s ease,
    border-color 0.15s ease, box-shadow 0.15s ease,
    -webkit-box-shadow 0.15s ease;
  opacity: 1;
}
</style>
